export default "__VITE_ASSET__D$5e4bo___"